/**
 * In-memory portal CSRF token from GET /api/user (Phase B). Cleared on logout.
 * @module src/utils/portalCsrfStore
 */

let portalCsrfToken: string | null = null;

/** Stores the CSRF token issued at login / getUser. */
export function setPortalCsrfToken(token: string | null | undefined): void {
  portalCsrfToken = token?.trim() || null;
}

/** Returns the current portal CSRF token for mutating API requests. */
export function getPortalCsrfToken(): string | null {
  return portalCsrfToken;
}

/** Clears the stored token (call on logout). */
export function clearPortalCsrfToken(): void {
  portalCsrfToken = null;
}
